import { create } from 'zustand';
import { platform } from '@kapture/platform';

interface UiState {
  /** Short-lived toast messages. Kept in-memory — no need to persist. */
  toasts: Array<{ id: string; message: string; tone: 'good' | 'warn' | 'danger' | 'neutral' }>;
  pushToast(message: string, tone?: 'good' | 'warn' | 'danger' | 'neutral'): void;
  dismissToast(id: string): void;
}

/**
 * Transient UI state that doesn't belong in TanStack Query (server/DB
 * state) or in `captureSessionStore` (the current capture-in-progress).
 *
 * Today this just drives toasts; new slices land alongside (e.g. an
 * onboarding-complete flag when we ship permissions, phase 4).
 */
export const useUiStore = create<UiState>((set) => ({
  toasts: [],
  pushToast(message, tone = 'neutral') {
    const id = platform().ids.uuid();
    set((state) => ({ toasts: [...state.toasts, { id, message, tone }] }));
    // Auto-dismiss after 2.8s — plenty for Sarah to read on a noisy site.
    setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
    }, 2800);
  },
  dismissToast(id) {
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
  },
}));
